AC_SERVICES.addListener('Table.Ready', () => {
    var _a, _b;
    const numElement = document.querySelector('.tablenav-pages .displaying-num');
    if (numElement) {
        let numberFormatted = numElement.innerHTML.split(' ')[0];
        let number = numElement.innerHTML.replace(/\D/g, '');
        (_b = (_a = AC_SERVICES.getService('Editing')) === null || _a === void 0 ? void 0 : _a.getService('BulkSelectionRow')) === null || _b === void 0 ? void 0 : _b.setTotalItems(parseInt(number), numberFormatted);
    }
});
AC_SERVICES.filters.addFilter('table_row_id', (item_id, payload) => {
    var _a, _b;
    let row = payload.row;
    if (Number.isNaN(item_id)) {
        item_id = (_b = (_a = row.querySelector('.check-column input[name="order[]"]')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0;
    }
    return item_id;
});
class OrderPlacement {
    place() {
        var _a, _b;
        const tableTop = document.querySelector('.tablenav.top');
        const container = tableTop === null || tableTop === void 0 ? void 0 : tableTop.querySelector(".alignleft.actions:not(.bulkactions)");
        if (!tableTop || !container) {
            return;
        }
        new AC_SERVICES.$(container)
            .removeClass('alignleft')
            .addClass('acp-smartfilter-actions')
            .prependSelfTo(tableTop);
        (_a = AC_SERVICES.$.find('.acp-smartfilters')) === null || _a === void 0 ? void 0 : _a.prependSelfTo(container);
        (_b = AC_SERVICES.$.find('#post-query-submit')) === null || _b === void 0 ? void 0 : _b.appendSelfTo(container);
        const resetFilters = AC_SERVICES.getService('ResetFilters');
        if (resetFilters) {
            container.append(resetFilters.getElement());
        }
    }
}
AC_SERVICES.addListener('Search.PlacementFactory', (d) => {
    d.register('wc_order', new OrderPlacement());
    d.register('wc_order_subscription', new OrderPlacement());
});
export {};
